import React from "react";
import { ArrowLeft } from "lucide-react";
import { useLocation, useNavigate } from 'react-router-dom';
import CreateTaskForm from "./CreateTaskForm";
import { useTranslation } from 'react-i18next';


const CreateTask = (props) => {
  const { t } = useTranslation();

  const { state } = useLocation();
  const navigate = useNavigate();
  const edit = state?.edit;

  return (
    <>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@500;600;700;800&display=swap');`}</style>
      <div style={{ margin: "8px", fontFamily: "'Poppins', 'Segoe UI', sans-serif" }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            padding: "10px 14px",
            borderRadius: "10px",
            background: "linear-gradient(120deg, #2E6DA4 0%, #3B82C4 100%)",
            boxShadow: "0 2px 6px rgba(46,109,164,0.2)",
          }}
        >
          <ArrowLeft
            size={18}
            color="#fff"
            className="cursor-pointer"
            onClick={() => navigate(-1)}
          />
          <div style={{ fontSize: "14px", fontWeight: 800, color: "#fff", letterSpacing: ".2px" }}>
            {edit ? t('Edit Task Details') : t('task_management_formheader')}
          </div>
        </div>
        <div style={{ marginTop: "10px", backgroundColor: "#fff", borderRadius: "10px" }}>
          <CreateTaskForm />
        </div>
      </div>
    </>
  );
};

export default CreateTask;
